// @flow
import * as React from 'react';
import { Switch, Redirect, Route, useRouteMatch } from 'react-router-dom';
import Settings from 'config/Settings';

export default function Home(): React.Element<any> {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path}>
        <Redirect to={Settings.country ? "/country-selection" : "/intro"} />
      </Route>
    </Switch>
  );
}
